import { render, staticRenderFns } from "./cSammelliste.vue?vue&type=template&id=a81dd15a&scoped=true"
import script from "./cSammelliste.vue?vue&type=script&lang=js"
export * from "./cSammelliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81dd15a",
  null
  
)

export default component.exports